import { render, staticRenderFns } from "./MobileBottomNav.vue?vue&type=template&id=651740a0&scoped=true"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"
import style0 from "./MobileBottomNav.vue?vue&type=style&index=0&id=651740a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651740a0",
  null
  
)

export default component.exports